import Util from "./public/utils";

let KEY_TASKPOSTER_DATA = 'zk_taskposter_data';
let KEY_PRIZEUNLOCK_DATA = 'zk_prize_data';
let KEY_FESTIVALSIGN_DATA = 'zk_festivalsign_data';
let KEY_GROUP_TASK_DATA = 'zk_group_task_data';
let KEY_RETAIL_DATA = 'zk_retail_data';
let KEY_GROUPBUY_DATA = 'zk_groupbuy_data';
let KEY_LIVECODE_DATA = 'zk_livecode_data';
let KEY_LIVECODE_KF_DATA = 'zk_livecode_kf_data';
let KEY_FORM_DATA = 'zk_form_data';
let KEY_USERINFO = 'zkuser';
let KEY_ALERT = 'zk_alert';
let KEY_RETAIL_DISTRI_DATA = 'zk_retail_distri_data';
let KEY_SHOP_SPEC_DATA = 'zk_shop_spec_data';
let KY_SHOP_GROUPUY_DATA = 'zk_retail_groupbuy_data';
let KEY_SHOP_GROUPBUYLADDER_DATA = 'zk_retail_Laddergroupbuy_data'
let KEY_ACTIVITY_INFORMATION_DATA = 'zk_activity_information_data'
let KEY_ACTIVITY_INFORMATION_DATA_PRO = 'zk_activity_information_data_pro'
let KEY_GROUP_CHAT_DATA = 'zk_group_chat_data'
let KEY_GROUP_CHAT_DATA_PRO = 'zk_group_chat_data_pro'
let KEY_REDPACKET_DATA = 'zk_redpacket_data'
let KEY_REDPACKET_DATA_PRO = 'zk_redpacket_data_pro'
let KEY_CHANNELQR_ACTIVITY_DATA = 'zk_channelqr_activity_data'
let KEY_FISSION_LOTTERY_ACTIVITY_DATA = 'zk_fission_lottery_data'
let KEY_FISSION_LOTTERY_ACTIVITY_DATA_PRO = 'zk_fission_lottery_data_pro'
let KEY_GROUP_RED_DATA = 'zk_group_red_data'
let KEY_GROUP_RED_DATA_PRO = 'zk_group_red_data_pro'

let KEY_CLOUD_DRAINAGE_MOBILE_FRIEND = 'zk_cloud_drainage_mobile_friend'
let KEY_CLOUD_DEAINAGE_GROUP_CHAT_FRIEND = 'zk_cloud_drainage_group_chat_friend'

let KEY_CLOUD_CUSTOMER_SOP = 'zk_cloud_customer_sop'
let KEY_CLOUD_CUSTOMER_SOP_TEMPLATE = 'zk_cloud_customer_sop_template'
let KEY_CLOUD_GROUP_CHAT_SOP = 'zk_cloud_group_chat_sop'
let KEY_CLOUD_CUSTOMER_KEYWORD_CREATE = 'zk_cloud_customer_keyword_create'
let KEY_CLOUD_ACCOUNT_REMARK_CREATE = 'zk_cloud_account_remark_create'
let KEY_CLOUD_ACCOUNT_FRIEND_GROUPSEND_CREATE = 'zk_cloud_account_friend_groupsend_create'
let KEY_CLOUD_GROUPCHAT_GROUPSEND_CREATE = 'zk_cloud_groupchat_groupsend_create'

let KEY_CLOUD_GROUPCHAT_KEYWORD_CREATE = 'zk_cloud_groupchat_keyword_create'
let KEY_CLOUD_GROUPCHAT_ERRORCHECK_CREATE = 'zk_cloud_groupchat_errorcheck_create'
let KEY_CLOUD_AUTO_INVITE = 'zk_cloud_auto_invite' //高级拉群
let KEY_CLOUD_CUSTOMER_MEDIA = 'zk_cloud_customer_media' //素材库
let KEY_CLOUD_TALK_LIST = 'zk_cloud_talk_list' //话术库
let KEY_CLOUD_GROUP_CHAT_NOTICE_CREATE = 'zk_cloud_groupchat_notice_create' //群公告
let KEY_CLOUD_GROUP_CHAT_LIVECODE_CREATE = 'zk_cloud_groupchat_livecode_create' //群活码
let KEY_CLOUD_GROUP_CHAT_ROOMWELMSG_CREATE = 'zk_cloud_groupchat_roomwelmsg_create' //入群欢迎语
let KEY_CLOUD_GROUP_CHAT_KWPULLGROUP_CREATE = 'zk_cloud_groupchat_kwpullgroup_create' //关键词拉群

let KEY_SUB_ACCOUNT_CREATE = 'zk_sub_account_create' //子账号创建

class Store {

    static setSubAccountData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_SUB_ACCOUNT_CREATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getSubAccountData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_SUB_ACCOUNT_CREATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteSubAccountData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_SUB_ACCOUNT_CREATE + user.id);
        }
    }

    static setCloudKWPullGroupData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_GROUP_CHAT_KWPULLGROUP_CREATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudKWPullGroupData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_GROUP_CHAT_KWPULLGROUP_CREATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudKWPullGroupData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_GROUP_CHAT_KWPULLGROUP_CREATE + user.id);
        }
    }

    static setCloudRoomWelMsgData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_GROUP_CHAT_ROOMWELMSG_CREATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudRoomWelMsgData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_GROUP_CHAT_ROOMWELMSG_CREATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudRoomWelMsgData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_GROUP_CHAT_ROOMWELMSG_CREATE + user.id);
        }
    }

    static setCloudRLivecodeData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_GROUP_CHAT_LIVECODE_CREATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudRLivecodeData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_GROUP_CHAT_LIVECODE_CREATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudRLivecodeData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_GROUP_CHAT_LIVECODE_CREATE + user.id);
        }
    }

    static setCloudGroupNoticeData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_GROUP_CHAT_NOTICE_CREATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudGroupNoticeData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_GROUP_CHAT_NOTICE_CREATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudGroupNoticeData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_GROUP_CHAT_NOTICE_CREATE + user.id);
        }
    }

    static setCloudGroupErrorCheckData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_GROUPCHAT_ERRORCHECK_CREATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudGroupErrorCheckData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_GROUPCHAT_ERRORCHECK_CREATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudGroupErrorCheckData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_GROUPCHAT_ERRORCHECK_CREATE + user.id);
        }
    }

    static setCloudGroupKeywordData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_GROUPCHAT_KEYWORD_CREATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudGroupKeywordData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_GROUPCHAT_KEYWORD_CREATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudGroupKeywordData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_GROUPCHAT_KEYWORD_CREATE + user.id);
        }
    }

    static setCloudGroupsendData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_GROUPCHAT_GROUPSEND_CREATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudGroupsendData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_GROUPCHAT_GROUPSEND_CREATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudGroupsendData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_GROUPCHAT_GROUPSEND_CREATE + user.id);
        }
    }

    static setCloudFriendGroupsendData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_ACCOUNT_FRIEND_GROUPSEND_CREATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudFriendGroupsendData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_ACCOUNT_FRIEND_GROUPSEND_CREATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudFriendGroupsendData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_ACCOUNT_FRIEND_GROUPSEND_CREATE + user.id);
        }
    }

    static setCloudRemarkData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_ACCOUNT_REMARK_CREATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudRemarkData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_ACCOUNT_REMARK_CREATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudRemarkData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_ACCOUNT_REMARK_CREATE + user.id);
        }
    }

    static setCloudKeywordData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_CUSTOMER_KEYWORD_CREATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudKeywordData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_CUSTOMER_KEYWORD_CREATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudKeywordData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_CUSTOMER_KEYWORD_CREATE + user.id);
        }
    }

    static setTaskposterData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_TASKPOSTER_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getTaskposterData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_TASKPOSTER_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteTaskposterData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_TASKPOSTER_DATA + user.id);
        }
    }

    static setPrizeUnlockData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_PRIZEUNLOCK_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getPrizeUnlockData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_PRIZEUNLOCK_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deletePrizeUnlockData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_PRIZEUNLOCK_DATA + user.id);
        }
    }

    static setFestivalSignData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO)
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_FESTIVALSIGN_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getFestivalSignData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_FESTIVALSIGN_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteFestivalSignData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_FESTIVALSIGN_DATA + user.id);
        }
    }

    static setUserInfo(info) {
        if (info) {
            window.sessionStorage.setItem(KEY_USERINFO, JSON.stringify(info));
        }
    }

    static getUserInfo() {
        var userInfo = window.sessionStorage.getItem(KEY_USERINFO);
        if (userInfo) {
            userInfo = JSON.parse(userInfo);
            return userInfo;
        }
    }

    static setTagList(tagList) {
        var list = [];
        for (var i = 0; i < tagList.length; i++) {
            list.push({
                id: tagList[i].id,
                wId: tagList[i].wId,
                name: tagList[i].name,
            })
        }
        this.tagList = list;
    }

    static getTagList() {
        return this.tagList;
    }

    static setGroupTaskData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_GROUP_TASK_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getGroupTaskData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_GROUP_TASK_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteGroupTaskData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_GROUP_TASK_DATA + user.id);
        }
    }


    static setRetailData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_RETAIL_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getRetailData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_RETAIL_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteRetailData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_RETAIL_DATA + user.id);
        }
    }

    static setGroupBuyData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_GROUPBUY_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getGroupBuyData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_GROUPBUY_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteGroupBuyData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_GROUPBUY_DATA + user.id);
        }
    }


    // 活码
    static setLiveCodeData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_LIVECODE_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getLiveCodeData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_LIVECODE_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteLiveCodeData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_LIVECODE_DATA + user.id);
        }
    }

    // 客服活码
    static setLiveCodeKfData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_LIVECODE_KF_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getLiveCodeKfData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_LIVECODE_KF_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteLiveCodeKfData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_LIVECODE_KF_DATA + user.id);
        }
    }

    // 海报弹窗
    static setAlertData(data) {
        if (data) {
            let user = '_modal';
            if (user) {
                window.localStorage.setItem(KEY_ALERT + user, data);
            }
        }
    }

    static getAlertData() {
        let user = '_modal';
        if (user) {
            let data = window.localStorage.getItem(KEY_ALERT + user);
            if (data) {
                return data;
            }
        }
    }

    static deleteAlertData() {
        let user = '_modal';
        if (user) {
            window.localStorage.removeItem(KEY_ALERT + user);
        }
    }

    // 表单
    static setFormData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_FORM_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getFormData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_FORM_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteFormData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_FORM_DATA + user.id);
        }
    }

    //  分销
    static setRetailDistriData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_RETAIL_DISTRI_DATA + user.id, JSON.stringify(data));
            }
        }
    }


    static getRetailDistriData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_RETAIL_DISTRI_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static getUserID() {
        let user = window.sessionStorage.getItem(KEY_USERINFO)
        if (user) {
            user = JSON.parse(user);
            return user.id;
        }
    }

    static delRetailDistriData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_RETAIL_DISTRI_DATA + user.id);
        }
    }

    static setShopSpecData(data) {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.setItem(KEY_SHOP_SPEC_DATA + user.id, JSON.stringify(data));
        }
    }

    static getShopSpecData() {
        // let data = window.sessionStorage.getItem(KEY_SHOP_SPEC_DATA +user.id);
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_SHOP_SPEC_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static delShopSpecData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_SHOP_SPEC_DATA + user.id);
        }
    }

    //拼团
    static setRetailGroupBuyData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KY_SHOP_GROUPUY_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getRetailGroupBuyData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KY_SHOP_GROUPUY_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static delRetailGroupBuyData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KY_SHOP_GROUPUY_DATA + user.id);
        }
    }

//    阶梯拼团
    static setRetailLadderGroupBuyData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_SHOP_GROUPBUYLADDER_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getRetailGroupBuyLadderData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_SHOP_GROUPBUYLADDER_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static delRetailGroupBuyLaaderData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_SHOP_GROUPBUYLADDER_DATA + user.id);
        }
    }

//任务宝活动 客户裂变-普通活动
    static setCustomerActivityInformation(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_ACTIVITY_INFORMATION_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getCustomerActivityInformation() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_ACTIVITY_INFORMATION_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCustomerActivityInformation() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_ACTIVITY_INFORMATION_DATA + user.id);
        }
    }

    //任务宝活动 客户裂变-增强活动
    static setCustomerActivityInformationPro(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_ACTIVITY_INFORMATION_DATA_PRO + user.id, JSON.stringify(data));
            }
        }
    }

    static getCustomerActivityInformationPro() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_ACTIVITY_INFORMATION_DATA_PRO + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCustomerActivityInformationPro() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_ACTIVITY_INFORMATION_DATA_PRO + user.id);
        }
    }

//群裂变活动 -普通活动
    static setCorpGroupChatInformation(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_GROUP_CHAT_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getCorpGroupChatInformation() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_GROUP_CHAT_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCorpGroupChatInformation() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_GROUP_CHAT_DATA + user.id);
        }
    }

    //群裂变活动 -增强活动
    static setCorpGroupChatInformationPro(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_GROUP_CHAT_DATA_PRO + user.id, JSON.stringify(data));
            }
        }
    }

    static getCorpGroupChatInformationPro() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_GROUP_CHAT_DATA_PRO + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCorpGroupChatInformationPro() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_GROUP_CHAT_DATA_PRO + user.id);
        }
    }

    //红包裂变 普通活动
    static setRedpacketInformation(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_REDPACKET_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getRedpacketInformation() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_REDPACKET_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteRedpacketInformation() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_REDPACKET_DATA + user.id);
        }
    }

    //红包裂变 增强活动
    static setRedpacketInformationPro(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_REDPACKET_DATA_PRO + user.id, JSON.stringify(data));
            }
        }
    }

    static getRedpacketInformationPro() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_REDPACKET_DATA_PRO + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteRedpacketInformationPro() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_REDPACKET_DATA_PRO + user.id);
        }
    }

    //渠道活码
    static setDrainageChannelQrrActivityData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CHANNELQR_ACTIVITY_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getDrainageChannelQrrActivityData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CHANNELQR_ACTIVITY_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteDrainageChannelQrrActivityData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CHANNELQR_ACTIVITY_DATA + user.id);
        }
    }

    //抽奖裂变 - 普通活动
    static setFissionLotteryQrrActivityData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_FISSION_LOTTERY_ACTIVITY_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getFissionLotteryQrrActivityData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_FISSION_LOTTERY_ACTIVITY_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteFissionLotteryQrrActivityData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_FISSION_LOTTERY_ACTIVITY_DATA + user.id);
        }
    }

    //抽奖裂变 - 增强活动
    static setFissionLotteryQrrActivityDataPro(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_FISSION_LOTTERY_ACTIVITY_DATA_PRO + user.id, JSON.stringify(data));
            }
        }
    }

    static getFissionLotteryQrrActivityDataPro() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_FISSION_LOTTERY_ACTIVITY_DATA_PRO + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteFissionLotteryQrrActivityDataPro() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_FISSION_LOTTERY_ACTIVITY_DATA_PRO + user.id);
        }
    }

    //社群红包裂变 普通活动
    static setGroupRedInformation(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_GROUP_RED_DATA + user.id, JSON.stringify(data));
            }
        }
    }

    static getGroupRedInformation() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_GROUP_RED_DATA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteGroupRedInformation() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_GROUP_RED_DATA + user.id);
        }
    }

    //社群红包裂变 增强活动
    static setGroupRedInformationPro(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_GROUP_RED_DATA_PRO + user.id, JSON.stringify(data));
            }
        }
    }

    static getGroupRedInformationPro() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_GROUP_RED_DATA_PRO + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteGroupRedInformationPro() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_GROUP_RED_DATA_PRO + user.id);
        }
    }


    //紫鲲云
    //手机号加好友
    static setCloudDrainageMobileFrientData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_DRAINAGE_MOBILE_FRIEND + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudDrainageMobileFrientData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_DRAINAGE_MOBILE_FRIEND + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudDrainageMobileFrientData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_DRAINAGE_MOBILE_FRIEND + user.id);
        }
    }

    //群加好友
    static setCloudDrainageGroupChatData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_DEAINAGE_GROUP_CHAT_FRIEND + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudDrainageGroupChatData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_DEAINAGE_GROUP_CHAT_FRIEND + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudDrainageGroupChatData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_DEAINAGE_GROUP_CHAT_FRIEND + user.id);
        }
    }


    //群sop
    static setCloudGroupChatSopData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_GROUP_CHAT_SOP + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudGroupChatSopData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_GROUP_CHAT_SOP + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudGroupChatSoptData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_GROUP_CHAT_SOP + user.id);
        }
    }

    //好友sop
    static setCloudCustomerSopData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_CUSTOMER_SOP + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudCustomerSopData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_CUSTOMER_SOP + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudCustomerSoptData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_CUSTOMER_SOP + user.id);
        }
    }

    //sop 模板
    static setCloudCustomerSopTemplateData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_CUSTOMER_SOP_TEMPLATE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudCustomerSopTemplateData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_CUSTOMER_SOP_TEMPLATE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudCustomerSopTemplateData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_CUSTOMER_SOP_TEMPLATE + user.id);
        }
    }

    //高级拉群
    static setCloudAutoInviteData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_AUTO_INVITE + user.id, JSON.stringify(data));
            }
        }
    }

    static getCloudAutoInviteData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_AUTO_INVITE + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCloudAutoInviteData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_AUTO_INVITE + user.id);
        }
    }

    //素材库
    static setCustomerMediaData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_CUSTOMER_MEDIA + user.id, JSON.stringify(data));
            }
        }
    }

    static getCustomerMediaData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_CUSTOMER_MEDIA + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteCustomerMediaData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_CUSTOMER_MEDIA + user.id);
        }
    }

    //话术库
    static setTalkListData(data) {
        if (data) {
            let user = window.sessionStorage.getItem(KEY_USERINFO);
            if (user) {
                user = JSON.parse(user);
                window.sessionStorage.setItem(KEY_CLOUD_TALK_LIST + user.id, JSON.stringify(data));
            }
        }
    }

    static getTalkListData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(KEY_CLOUD_TALK_LIST + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static deleteTalkListData() {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.removeItem(KEY_CLOUD_TALK_LIST + user.id);
        }
    }


    //存筛选条件
    static setAddFriendQueryParams(key, params, pageNum) {
        Store.setQueryParams(key, params, pageNum);
    }

    static setQueryParams(key, params, pageNum) {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            window.sessionStorage.setItem(key + user.id, JSON.stringify({
                params: params,
                pageNum: pageNum
            }));
        }
    }

    //取筛选条件
    static getQueryParams(key) {
        let user = window.sessionStorage.getItem(KEY_USERINFO);
        if (user) {
            user = JSON.parse(user);
            let data = window.sessionStorage.getItem(key + user.id);
            if (data) {
                return JSON.parse(data);
            }
        }
    }

    static setChatSendMsg(value) {
        let wxid = Util.getUrlArg("wxid");
        let chat_wxid = Util.getUrlArg("chat_wxid");
        if (!Util.isEmpty(wxid) && !Util.isEmpty(chat_wxid)) {
            let key = 'cc_' + wxid + '_' + chat_wxid;
            window.sessionStorage.setItem(key, value)
        }
    }

    static getChatSendMsg() {
        let wxid = Util.getUrlArg("wxid");
        let chat_wxid = Util.getUrlArg("chat_wxid");
        if (!Util.isEmpty(wxid) && !Util.isEmpty(chat_wxid)) {
            let key = 'cc_' + wxid + '_' + chat_wxid;
            let value = window.sessionStorage.getItem(key);
            if (!Util.isEmpty(value)) {
                return value;
            }
        }
        return '';
    }

    static clearChatSendMsg() {
        let wxid = Util.getUrlArg("wxid");
        let chat_wxid = Util.getUrlArg("chat_wxid");
        if (!Util.isEmpty(wxid) && !Util.isEmpty(chat_wxid)) {
            let key = 'cc_' + wxid + '_' + chat_wxid;
            window.sessionStorage.removeItem(key);
        }
    }
}

export default Store